import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=d9235e90"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports